// eslint-disable-next-line @typescript-eslint/dot-notation
import { HisSearchResultRow, HisAuthService, HisBaseGlobalsService, HisUiService } from 'hisng';
import { AbstractDetailViewListEntry, SimpleLinkDefinition, RowLabels } from './abstract-detail-view-list-entry';
import { DetailViewListUtils } from './detail-view-list-utils';
import { PsvPersonProfile } from '../../../../common/model/person/psvPersonProfile';
import { PersonDetailViewSearchResultComponent } from '../person-detail-view-search-result.component';

export class ActivityDetailViewListEntry extends AbstractDetailViewListEntry {

    rowLabels: RowLabels = {
        title: 'fs.res.researchActivity.ResearchActivity.title',
        groupName: 'fs.res.researchActivity.ResearchActivity.groupName',
        parentType: 'fs.res.researchActivity.ResearchActivity.researchActivityTypeValue.parent',
        parentTypeHiskeyId: 'fs.res.researchActivity.ResearchActivity.researchActivityTypeValue.parent.hiskeyId',
        type: 'fs.res.researchActivity.ResearchActivity.researchActivityTypeValue',
        typeHiskeyId: 'fs.res.researchActivity.ResearchActivity.researchActivityTypeValue.hiskeyId',
        dateFrom: 'fs.res.researchActivity.ResearchActivity.dateFrom',
        dateTo: 'fs.res.researchActivity.ResearchActivity.dateTo',
        researchPartner: 'fs.res.researchActivity.ResearchActivity.researchPartner',
        dateOfAssessment: 'fs.res.researchActivity.ResearchActivity.dateOfAssessment',
        client: 'fs.res.researchActivity.ResearchActivity.client',
        fundingLine: 'fs.res.researchActivity.ResearchActivity.fundingLine',
        ownRole: 'fs.res.researchActivity.ResearchActivity.ownRole',
        contributionType: 'fs.res.researchActivity.ResearchActivity.contributionType',
        journalId: 'fs.res.researchActivity.ResearchActivity.journal.id',
        journalTitle: 'fs.res.researchActivity.ResearchActivity.journal.defaulttext',
        journalShortTitle: 'fs.res.researchActivity.ResearchActivity.journal.shorttext',
        researchRelationshipResearchPartner: 'fs.res.researchActivity.ResearchActivity.researchRelationship.researchPartner',
        position: 'fs.res.researchActivity.ResearchActivity.position',
    };

    private auth: HisAuthService;

    constructor(
        hisBaseGlobalsService: HisBaseGlobalsService,
        hisUiService: HisUiService,
        person: PsvPersonProfile,
        personDetailViewSearchResultComponent: PersonDetailViewSearchResultComponent,
        hisAuthService: HisAuthService) {

        super(hisBaseGlobalsService, hisUiService, person, personDetailViewSearchResultComponent);
        this.auth = hisAuthService;
    }

    getOverSearchResultLink(): SimpleLinkDefinition {
        return null;
    }

    getSubheading(row: HisSearchResultRow, data: any, index: number): string {
        let currentType = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['parentType']);
        if (index === 0) {
            return currentType;
        }

        let lastType = DetailViewListUtils.getRowByLabelKey(data[index - 1], this.rowLabels['parentType']);
        if (lastType !== currentType) {
            return currentType;
        }
        return null;
    }

    getHeaderLine(row: HisSearchResultRow): string {
        return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['type']);
    }

    getTitleLine(row: HisSearchResultRow): string {
        let typeHiskeyId = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['typeHiskeyId']);
        switch (parseInt(typeHiskeyId, 10)) {
            // Ausgründungen
            case 1002: // Proof of Concept
            case 1003: // Mentorentätigkeit
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
            // Herausgeberschaft
            case 1012: // Herausgeberschaft Zeitschrift
                return this.getJournalTitleLine(row);
            // Gutachtertätigkeiten
            case 1022: // Gutachten für Publikationen
                return this.getJournalTitleLine(row);
            case 1023: // Gutachten für Drittmittelanträge
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['fundingLine']);
            // Mitgliedschaften
            case 1032: // Mitgliedschaft in Gutachtergremium
            case 1033: // Mitgliedschaft in Herausgeberbeirat
            case 1034: // Mitgliedschaft in wiss. Gremien als Hochschulvertreter/-in
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['groupName']);
            // Veranstaltungen
            case 1042: // Ausrichtung eigener wiss. Konferenzen/Praxisevents
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
            case 1043: // Teilnahme/Mitwirkung an Veranstaltungen mit eigenen Beiträgen
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
            default:
                return null;
        }
    }

    getToolTip(row: HisSearchResultRow): string {
        return null;
    }

    getTitleLink(row: HisSearchResultRow): string {
        let typeHiskeyId = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['typeHiskeyId']);
        switch (parseInt(typeHiskeyId, 10)) {
            // Herausgeberschaft
            case 1012: // Herausgeberschaft Zeitschrift
                return this.getJournalTitleLink(row);
            // Gutachtertätigkeiten
            case 1022: // Gutachten für Publikationen
                return this.getJournalTitleLink(row);
            // Veranstaltungen
        }
        return null;
    }

    getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        let typeHiskeyId = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['typeHiskeyId']);
        switch (parseInt(typeHiskeyId, 10)) {
            // Ausgründungen
            case 1002: // Proof of Concept
            case 1003: // Mentorentätigkeit
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['researchRelationshipResearchPartner']);
            // Herausgeberschaft
            case 1012: // Herausgeberschaft Zeitschrift
                return null;
            // Gutachtertätigkeiten
            case 1022: // Gutachten für Publikationen
                return null;
            case 1023: // Gutachten für Drittmittelanträge
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['client']);
            // Mitgliedschaften
            case 1032: // Mitgliedschaft in Gutachtergremium
            case 1033: // Mitgliedschaft in Herausgeberbeirat
            case 1034: // Mitgliedschaft in wiss. Gremien als Hochschulvertreter/-in
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['client']);
            // Veranstaltungen
            case 1042: // Ausrichtung eigener wiss. Konferenzen/Praxisevents
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['position']);
            case 1043: // Teilnahme/Mitwirkung an Veranstaltungen mit eigenen Beiträgen
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['contributionType']);
            default:
                return null;
        }
    }

    getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        return null;
    }

    isExtendable(row: HisSearchResultRow): boolean {
        return false;
    }

    isExtendableSecond(row: HisSearchResultRow): boolean {
        return false;
    }

    getFooterLine(row: HisSearchResultRow): string {
        let typeHiskeyId = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['typeHiskeyId']);
        switch (parseInt(typeHiskeyId, 10)) {
            // Gutachtertätigkeiten
            case 1022: // Gutachten für Publikationen
            case 1023: // Gutachten für Drittmittelanträge
                return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['dateOfAssessment']);
            default:
                return this.getFromToDate(row);
        }
    }

    private getJournalTitleLine(row: HisSearchResultRow): string {
        let journalTitle = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['journalTitle']);
        let journalShortTitle = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['journalShortTitle']);
        return journalTitle + (journalShortTitle ? ' (' + journalShortTitle + ')' : '');
    }

    private getJournalTitleLink(row: HisSearchResultRow): string {
        let journalId = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['journalId']);
        return '/a/fs.res.frontend/pub/journal/view/' + journalId + '?showBackButton=true';
    }

    private getFromToDate(row: HisSearchResultRow): string {
        let dateFrom = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['dateFrom']);
        let dateTo = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['dateTo']);
        if (dateFrom && dateTo) {
            return dateFrom + ' - ' + dateTo;
        } else if (dateFrom) {
            return this.hisUiService.translate('fs.res.researchActivity.detail.since') + ' ' + dateFrom;
        } else if (dateTo) {
            return dateTo;
        }
        return null;
    }

}

